<div class="settings-container">

  <!-- Sticky Save/Cancel Bar -->
  <div class="settings-actions" *ngIf="editing">
    <button mat-raised-button color="primary" (click)="save($event.target)" [disabled]="!hasChanges" i18n-title="@@Save" title="Save"><mat-icon>save</mat-icon> <span i18n="@@Save">Save</span></button>
    <button mat-raised-button (click)="cancel()" i18n-title="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel" title="Cancel"><mat-icon>cancel</mat-icon> <span i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</span></button>
  </div>
  <div class="settings-actions" *ngIf="!editing">
    <button mat-raised-button color="primary" (click)="edit()" i18n-title="@@Edit" title="Edit"><mat-icon>edit</mat-icon> <span i18n="@@Edit">Edit</span></button>
  </div>

  <mat-accordion multi="true" displayMode="flat">

    <!-- Section: Connection Status -->
    <mat-expansion-panel [expanded]="true" *ngIf="ecommerceConnection.type === 'SHOPIFY' || ecommerceConnection.type === 'WOOCOMMERCE'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">sync</mat-icon>
          <span i18n="@@Connection Status">Connection Status</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="settings-description" i18n="@@ConnectionStatusDescription">Connection status information to show the most recent connection, most recent synchronization of orders, products and shipping status</div>
      <app-ecommerce-connection-status [ecommerceConnection]="ecommerceConnection"></app-ecommerce-connection-status>
    </mat-expansion-panel>

    <!-- Section: Type-Specific Settings -->
    <mat-expansion-panel [expanded]="true" *ngIf="ecommerceConnection.type === 'SHOPIFY'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">settings</mat-icon>
          <span>{{ecommerceConnection.type | languageString }}&nbsp;</span><span i18n="@@Settings">Settings</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form class="section-form">
        <h4 class="settings-heading" i18n="@@ShopifyStoreIdentifier">Shopify Store Identifier</h4>
        <div class="settings-description" i18n="@@ShopifyStoreIdentifierDescription">This value is the value where the ______ part to the URL (web site address) when using Shopify Admin https://admin.shopify.com/store/______/settings/general</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@ShopifyStoreIdentifier">Shopify Store Identifier</mat-label>
          <textarea name="remoteURL" [(ngModel)]="ecommerceConnection.remoteURL" matInput></textarea>
        </mat-form-field>
        <h4 class="settings-heading" i18n="@@ShopifyAPISecretKey">Shopify API Secret Key</h4>
        <div class="settings-description"><span i18n="@@ShopifyAPISecretKeyDescription">This value is displayed only one time during setup. See </span><a href="www.snowfallpress.com/ShopifyAPISecretKey" i18n-href="@@ShopifyAPISecretKeyInstructionsURL" i18n="@@ShopifyAPISecretKeyInstructions">Shopify API SecretKey Instructions</a></div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@ShopifyAPISecretKey">Shopify API Secret Key</mat-label>
          <input name="remoteKey" [(ngModel)]="ecommerceConnection.remoteKey" matInput [type]="showSecrets['shopifyKey'] ? 'text' : 'password'" autocomplete="off">
          <button mat-icon-button matSuffix type="button" (click)="showSecrets['shopifyKey'] = !showSecrets['shopifyKey']"
                  [title]="showSecrets['shopifyKey'] ? 'Hide' : 'Show'">
            <mat-icon>{{showSecrets['shopifyKey'] ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
        <h4 class="settings-heading" i18n="@@Vendor">Vendor</h4>
        <div class="settings-description"><span i18n="@@VendorDescription">The vendor is set on each order and is also used to identify which orders are designated for us to fulfill.</span></div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Vendor">Vendor</mat-label>
          <textarea name="vendor" [ngModel]="ecommerceConnection.options?.vendor" (change)="ecommerceConnection.options ? ecommerceConnection.options['vendor'] = $event.target['value'] : ecommerceConnection.options = {}; ecommerceConnection.options['vendor'] = $event.target['value']" matInput></textarea>
        </mat-form-field>
      </form>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" *ngIf="ecommerceConnection.type === 'WOOCOMMERCE'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">settings</mat-icon>
          <span>{{ecommerceConnection.type | languageString }}&nbsp;</span><span i18n="@@Settings">Settings</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <form class="section-form">
        <h4 class="settings-heading" i18n="@@WooCommerceSiteBaseURL">WooCommerce Site Base URL</h4>
        <div class="settings-description" i18n="@@WooCommerceSiteBaseURLDescription">The site base URL will be like https://yourdomain.com/wp-json where yourdomain.com is replaced by your site</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@WooCommerceStoreIdentifier">WooCommerce Store Identifier</mat-label>
          <textarea name="remoteURL" [(ngModel)]="ecommerceConnection.remoteURL" matInput></textarea>
        </mat-form-field>
        <h4 class="settings-heading" i18n="@@WooCommerceConsumerKey">WooCommerce Consumer Key</h4>
        <div class="settings-description"><span i18n="@@WooCommerceConsumerKeyDescription">. See </span><a href="www.snowfallpress.com/WooCommerceAPI" i18n-href="@@WooCommerceAPIInstructionsURL" i18n="@@WooCommereConsumerKeyInstructions">WooCommerce API Consumer Key Instructions</a></div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@WooCommerceConsumerKey">WooCommerce Consumer Key</mat-label>
          <input name="remoteKey" [(ngModel)]="ecommerceConnection.remoteKey" matInput [type]="showSecrets['wooKey'] ? 'text' : 'password'" autocomplete="off">
          <button mat-icon-button matSuffix type="button" (click)="showSecrets['wooKey'] = !showSecrets['wooKey']"
                  [title]="showSecrets['wooKey'] ? 'Hide' : 'Show'">
            <mat-icon>{{showSecrets['wooKey'] ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
        <h4 class="settings-heading" i18n="@@WooCommerceConsumerSecret">WooCommerce Consumer Secret</h4>
        <div class="settings-description"><span i18n="@@WooCommerceConsumerSecretDescription">. See </span><a href="www.snowfallpress.com/WooCommerceAPI" i18n-href="@@WooCommerceAPIInstructionsURL" i18n="@@WooCommereConsumerSecretInstructions">WooCommerce Consumer Secret Instructions</a></div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@WooCommerceConsumerSecret">WooCommerce Consumer Secret</mat-label>
          <input name="remotePassword" [(ngModel)]="ecommerceConnection.remotePassword" matInput [type]="showSecrets['wooSecret'] ? 'text' : 'password'" autocomplete="off">
          <button mat-icon-button matSuffix type="button" (click)="showSecrets['wooSecret'] = !showSecrets['wooSecret']"
                  [title]="showSecrets['wooSecret'] ? 'Hide' : 'Show'">
            <mat-icon>{{showSecrets['wooSecret'] ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </mat-expansion-panel>

    <!-- CSV type - minimal -->
    <mat-expansion-panel [expanded]="true" *ngIf="ecommerceConnection.type === 'CSV'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">description</mat-icon>
          <span>{{ecommerceConnection.type | languageString }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- Unsupported type -->
    <mat-expansion-panel [expanded]="true" *ngIf="ecommerceConnection.type !== 'SHOPIFY' && ecommerceConnection.type !== 'WOOCOMMERCE' && ecommerceConnection.type !== 'CSV'">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">warning</mat-icon>
          <span>{{ecommerceConnection.type | languageString }}&nbsp;</span><span i18n="@@is not currently a supported type of ecommerce connection">is not currently a supported type of ecommerce connection</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
    </mat-expansion-panel>

    <!-- Section: Product Content -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">inventory_2</mat-icon>
          <span i18n="@@ProductContent">Product Content</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="section-form">
        <h4 class="settings-heading" i18n="@@ProductMatching">Product Matching</h4>
        <div class="settings-description" i18n="@@descriptionProductMatching">Choose how a line on an incoming order is matched to one of your products. Matching is an exact comparison, so the value on the order must be identical to the value on the product, including capitalization and punctuation.</div>
        <mat-radio-group class="radio-group-vertical" [value]="productIdentifierType" (change)="setProductIdentifierType($event.value)">
          <mat-radio-button value="ECOMMERCE_PRODUCT">
            <div class="radio-option">
              <strong i18n="@@ProductIdentifierEcommerceProduct">Match using the store's product record.</strong>
              <div class="radio-option-description" i18n="@@descriptionProductIdentifierEcommerceProduct">The product id sent by the store is looked up in the list of products synchronized from that store, which in turn points at one of your products. This is the standard behavior and the right choice unless you deliberately key your catalog on your own codes.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button value="CUSTOMER_PRODUCT_ID">
            <div class="radio-option">
              <strong i18n="@@ProductIdentifierCustomerProductId">Match the order's SKU to my product code.</strong>
              <div class="radio-option-description" i18n="@@descriptionProductIdentifierCustomerProductId">The SKU on the order line is compared to the Product Code you have assigned to each of your products. Order lines that arrive without a SKU cannot be matched this way.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button value="EAN13">
            <div class="radio-option">
              <strong i18n="@@ProductIdentifierEan13">Match the order's SKU to the product's EAN13.</strong>
              <div class="radio-option-description" i18n="@@descriptionProductIdentifierEan13">The SKU on the order line is compared to the EAN13 barcode number of each product. Only numeric SKUs can be matched this way.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button value="INTERNAL_PRODUCT_ID">
            <div class="radio-option">
              <strong i18n="@@ProductIdentifierInternalProductId">Match the store's product id to our internal product id.</strong>
              <div class="radio-option-description" i18n="@@descriptionProductIdentifierInternalProductId">The product id sent by the store is treated as one of our internal product id numbers. Choose this only if your store was set up to send our ids. Only numeric values can be matched this way.</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
        <div class="settings-description" i18n="@@noteProductMatchingScope">Only products in this organization that are not archived and are not proofs can be matched. Changing this setting affects orders received from now on; orders already received keep the products they were matched to.</div>

        <mat-divider></mat-divider>

        <h4 class="settings-heading" i18n="@@ProductContentSyncronization">Product Content Syncronization</h4>
        <h4 class="settings-heading" i18n="@@UpdateOfProductPropertiesAtTheEndOfTheDescription">Update Of Product Properties At The End Of The Description</h4>
        <h4 class="settings-heading" i18n="@@ProductPropertiesAreSentAsCustomFields">Product Properties Are Sent As Custom Fields</h4>
      </div>
    </mat-expansion-panel>

    <!-- Section: Orders -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">receipt</mat-icon>
          <span i18n="@@Orders">Orders</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="section-form">
        <h4 class="settings-heading" i18n="@@OrderApproval">Order Approval</h4>
        <h4 class="settings-heading" i18n="@@OrderPaymentStatus">Order Payment Status</h4>
      </div>

      <mat-divider></mat-divider>

      <!-- Order Release to Production Automation -->
      <div class="notification-subsection">
        <h3 class="settings-heading" i18n="@@Order Release To Production Automation">Order Release to Production Automation</h3>

        <!-- Setting 1: Check Cost vs Revenue -->
        <h4 class="settings-heading" i18n="@@Check Order Production Cost Against Revenue">Check Order Production Cost Against Revenue</h4>
        <div class="settings-description" i18n="@@descriptionCheckCostVsRevenue">If the revenue collected is less than the cost to produce and ship the order by the amount specified, then flag the order and hold it for review.</div>
        <mat-radio-group class="radio-group-vertical" [value]="ecommerceConnection.checkCostVsRevenue" (change)="ecommerceConnection.checkCostVsRevenue = $event.value">
          <mat-radio-button [value]="true">
            <div class="radio-option">
              <strong i18n="@@CheckCostVsRevenueEnabled">Check the order production cost against the revenue collected.</strong>
              <div class="radio-option-description" i18n="@@descriptionCheckCostVsRevenueEnabled">Orders where the revenue does not cover the production and shipping cost by the specified margin will be flagged and held for manual review.</div>
            </div>
          </mat-radio-button>
          <div class="radio-sub-setting" *ngIf="ecommerceConnection.checkCostVsRevenue">
            <h4 class="settings-heading" i18n="@@Cost Difference To Flag And Hold An Order">Cost Difference to Flag and Hold an Order</h4>
            <div class="settings-description" i18n="@@descriptionCheckCostVsRevenueMargin">If the total revenue minus the total cost is less than this value, the order will be flagged. A negative value indicates that an unprofitable order would be accepted as long as it is not more negative than the specified amount. A positive value requires at least the indicated margin for the order to avoid being flagged.</div>
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Margin Amount">Margin Amount</mat-label>
              <input matInput type="number" [(ngModel)]="ecommerceConnection.checkCostVsRevenueMargin" name="checkCostVsRevenueMargin" step="0.01">
              <span matSuffix>{{ecommerceConnection.currency || 'USD'}}</span>
            </mat-form-field>
          </div>
          <mat-radio-button [value]="false">
            <div class="radio-option">
              <strong i18n="@@CheckCostVsRevenueDisabled">Don't check the order production cost against the revenue collected.</strong>
              <div class="radio-option-description" i18n="@@descriptionCheckCostVsRevenueDisabled">All orders will be processed regardless of cost versus revenue.</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>

        <mat-divider></mat-divider>

        <!-- Setting 2: Automatic Order Release -->
        <h4 class="settings-heading" i18n="@@Automatic Order Release">Automatic Order Release</h4>
        <div class="settings-description" i18n="@@descriptionAutomaticOrderRelease">Choose how orders are released to production after they pass validation.</div>
        <mat-radio-group class="radio-group-vertical" [value]="getOrderReleaseMode()" (change)="setOrderReleaseMode($event.value)">
          <mat-radio-button value="MANUAL">
            <div class="radio-option">
              <strong i18n="@@ManualOrderRelease">Require manual approval for all orders.</strong>
              <div class="radio-option-description" i18n="@@descriptionManualOrderRelease">Orders will never be automatically released to production. A person must review and release each order.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button value="IMMEDIATE">
            <div class="radio-option">
              <strong i18n="@@ImmediateOrderRelease">Release orders immediately.</strong>
              <div class="radio-option-description" i18n="@@descriptionImmediateOrderRelease">Valid orders will be released to production as soon as possible without any hold period.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button value="DELAYED">
            <div class="radio-option">
              <strong i18n="@@DelayedOrderRelease">Hold orders before releasing.</strong>
              <div class="radio-option-description" i18n="@@descriptionDelayedOrderRelease">Orders will be held for the specified number of hours and then automatically released if not already released manually.</div>
            </div>
          </mat-radio-button>
          <div class="radio-sub-setting" *ngIf="getOrderReleaseMode() === 'DELAYED'">
            <h4 class="settings-heading" i18n="@@Hold Duration">Hold Duration</h4>
            <div class="settings-description" i18n="@@descriptionHoldDuration">The number of hours to hold an order before automatically releasing it to production.</div>
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Hours">Hours</mat-label>
              <input matInput type="number" [(ngModel)]="ecommerceConnection.automaticallyReleaseOrderHoldNumberOfHours" name="holdHours" min="1" step="1">
            </mat-form-field>
          </div>
        </mat-radio-group>
      </div>
    </mat-expansion-panel>

    <!-- Section: Shipping -->
    <mat-expansion-panel (opened)="onShippingPanelOpened()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">local_shipping</mat-icon>
          <span i18n="outbound delivery|Delivery of the order to the customer. Not Billing, and not the freight cost line.@@Shipping">Shipping</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div *ngIf="carrierServiceMapLoading" style="display: flex; align-items: center; gap: 8px; padding: 16px 0;">
        <mat-spinner diameter="24"></mat-spinner>
        <span i18n="@@Loading data">Loading data</span>
      </div>

      <!-- Setting 1: Default Carrier and Service Level -->
      <div *ngIf="!carrierServiceMapLoading">
      <div class="notification-subsection">
        <h4 class="settings-heading" i18n="@@Default Carrier and Service Level">Default Carrier and Service Level</h4>
        <div class="settings-description" i18n="@@descriptionDefaultCarrierService">Select the default carrier and level of service if none is communicated with the order, if the value communicated in the order does not map to a known value, or if the value is not valid for the address.</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Default Carrier and Service Level">Default Carrier and Service Level</mat-label>
          <mat-select [(ngModel)]="ecommerceConnection.defaultShippingService" name="defaultShippingService">
            <mat-option *ngFor="let cs of carrierServiceLevels" [value]="cs.ID">{{cs.carrier}} — {{cs.serviceLevel}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <!-- Setting 2: Default Free Carrier and Service Level -->
      <div class="notification-subsection">
        <h4 class="settings-heading" i18n="@@Default Free Carrier and Service Level">Default Free Carrier and Service Level</h4>
        <div class="settings-description" i18n="@@descriptionDefaultFreeCarrierService">Select the default carrier and level of service when the selected option is free shipping for the customer.</div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label i18n="@@Default Free Carrier and Service Level">Default Free Carrier and Service Level</mat-label>
          <mat-select [(ngModel)]="ecommerceConnection.defaultFreeShippingService" name="defaultFreeShippingService">
            <mat-option *ngFor="let cs of carrierServiceLevels" [value]="cs.ID">{{cs.carrier}} — {{cs.serviceLevel}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <!-- Setting 3: Carrier Service Map -->
      <div class="notification-subsection">
        <h4 class="settings-heading" i18n="@@Carrier and Service Level Code Mapping">Carrier and Service Level Code Mapping</h4>
        <div class="settings-description" i18n="@@descriptionCarrierServiceMap">Define the meaning of your ecommerce system's carrier and service level values. Each ecommerce carrier code must be unique and maps to a carrier service in our system.</div>

        <!-- Using default map (carrierServiceMap_ID is 0 or equals the type default) -->
        <div *ngIf="isUsingDefaultMap">
          <div class="carrier-map-default-notice">
            <div class="settings-description">
              <span i18n="@@standardizedMappingsLabel">Standardized carrier service level mappings for</span>&nbsp;<strong>{{ecommerceConnection.type | languageString}}</strong>
            </div>
          </div>

          <!-- Default mappings table (read-only) -->
          <table class="carrier-map-table" *ngIf="defaultMappings.length > 0">
            <thead>
              <tr>
                <th i18n="@@Ecommerce Carrier Code">Ecommerce Carrier Code</th>
                <th i18n="@@Carrier Service">Carrier Service</th>
                <th i18n="@@Source">Source</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let mapping of defaultMappings" class="carrier-map-default-row">
                <td class="carrier-map-default-cell">{{mapping.customerCarrierService}}</td>
                <td class="carrier-map-default-cell">{{getCarrierServiceLabel(mapping.carrierService)}}</td>
                <td class="carrier-map-default-cell"><mat-icon class="carrier-map-default-icon">public</mat-icon> <span i18n="@@Default">Default</span></td>
              </tr>
            </tbody>
          </table>

          <div class="carrier-map-button-bar">
            <button mat-raised-button color="primary" (click)="createCustomCarrierMap()" i18n="@@Create Custom Carrier Map">Create Custom Carrier Map</button>
            <button mat-stroked-button (click)="createCustomCarrierMap(true)" i18n="@@Create From Defaults">Create from Defaults</button>
          </div>
        </div>

        <!-- Using custom map -->
        <div *ngIf="hasCustomMap">
          <!-- Editable custom mappings table -->
          <table class="carrier-map-table" *ngIf="carrierServiceMappings.length > 0">
            <thead>
              <tr>
                <th i18n="@@Ecommerce Carrier Code">Ecommerce Carrier Code</th>
                <th i18n="@@Carrier Service">Carrier Service</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let mapping of carrierServiceMappings; let i = index" [class.carrier-map-matches-default]="isCustomCodeInDefaults(mapping)">
                <td>
                  <mat-form-field appearance="outline" class="full-width carrier-map-field">
                    <input matInput [(ngModel)]="mapping.customerCarrierService" [name]="'custCode_' + i"
                           (ngModelChange)="markMappingDirty(mapping)">
                    <mat-icon matSuffix *ngIf="isCustomCodeInDefaults(mapping)" class="carrier-map-standard-icon"
                              i18n-title="@@Matches a standardized mapping" title="Matches a standardized mapping">verified</mat-icon>
                  </mat-form-field>
                  <div *ngIf="isDuplicateCustomerCode(mapping)" class="carrier-map-error" i18n="@@Duplicate carrier code">Duplicate carrier code</div>
                </td>
                <td>
                  <mat-form-field appearance="outline" class="full-width carrier-map-field">
                    <mat-select [(ngModel)]="mapping.carrierService" [name]="'svcLevel_' + i"
                                (ngModelChange)="markMappingDirty(mapping)">
                      <mat-option *ngFor="let cs of carrierServiceLevels" [value]="cs.ID">{{cs.carrier}} — {{cs.serviceLevel}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
                <td class="carrier-map-actions">
                  <button mat-icon-button color="warn" (click)="deleteMapping(mapping)" i18n-title="destructive removal|Button that permanently destroys the record. Must be clearly different from Cancel, which only closes a dialog.@@Delete" title="Delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" *ngIf="dirtyMappings.has(mapping)"
                          [disabled]="!mapping.customerCarrierService || isDuplicateCustomerCode(mapping)"
                          (click)="saveMapping(mapping)" i18n-title="@@Save" title="Save">
                    <mat-icon>save</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="carrier-map-button-bar">
            <button mat-raised-button color="primary" (click)="addMapping()" i18n="@@Add Mapping">Add Mapping</button>
            <button mat-stroked-button *ngIf="carrierServiceMappings.length === 0" (click)="populateFromDefaults()" i18n="@@Populate from Defaults">Populate from Defaults</button>
          </div>

          <!-- Toggle to show default mappings for reference -->
          <div style="margin-top: 16px;">
            <button mat-stroked-button (click)="toggleDefaultMappings()">
              <mat-icon>{{showDefaultMappings ? 'visibility_off' : 'visibility'}}</mat-icon>&nbsp;
              <span i18n="@@showStandardizedMappingsFor">Standardized mappings for</span>&nbsp;<strong>{{ecommerceConnection.type | languageString}}</strong>
            </button>
          </div>

          <!-- Default mappings table (read-only, with add button) -->
          <div *ngIf="showDefaultMappings && defaultMappings.length > 0" style="margin-top: 8px;">
            <table class="carrier-map-table carrier-map-default-table">
              <thead>
                <tr>
                  <th i18n="@@Ecommerce Carrier Code">Ecommerce Carrier Code</th>
                  <th i18n="@@Carrier Service">Carrier Service</th>
                  <th i18n="@@Source">Source</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let mapping of defaultMappings" class="carrier-map-default-row">
                  <td class="carrier-map-default-cell">{{mapping.customerCarrierService}}</td>
                  <td class="carrier-map-default-cell">{{getCarrierServiceLabel(mapping.carrierService)}}</td>
                  <td class="carrier-map-default-cell"><mat-icon class="carrier-map-default-icon">public</mat-icon> <span i18n="@@Default">Default</span></td>
                  <td class="carrier-map-actions">
                    <button mat-icon-button color="accent" *ngIf="!isDefaultCodeAlreadyInCustom(mapping)"
                            (click)="addDefaultMappingToCustom(mapping)" i18n-title="@@Add to custom mappings" title="Add to custom mappings">
                      <mat-icon>add_circle_outline</mat-icon>
                    </button>
                    <mat-icon *ngIf="isDefaultCodeAlreadyInCustom(mapping)" class="carrier-map-already-added-icon" i18n-title="@@Already in custom mappings" title="Already in custom mappings">check_circle</mat-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>
    </mat-expansion-panel>

    <!-- Section: Notifications -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">notifications</mat-icon>
          <span i18n="@@Notifications">Notifications</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="section-form">
        <h4 class="settings-heading" i18n="@@Send Email Notifications">Send Email Notifications</h4>
        <div class="settings-description" i18n="@@descriptionNotifications">Configure email notifications for issues that need attention related to this ecommerce connection.</div>
        <mat-radio-group class="radio-group-vertical" [value]="ecommerceConnection.sendEmailMessage" (change)="ecommerceConnection.sendEmailMessage = $event.value">
          <mat-radio-button [value]="true">
            <div class="radio-option">
              <strong i18n="@@SendEmailNotificationsEnabled">Send email notifications for this connection.</strong>
              <div class="radio-option-description" i18n="@@descriptionSendEmailNotificationsEnabled">An email will be sent when there is an issue that needs attention related to this ecommerce connection, such as order problems or integration errors.</div>
            </div>
          </mat-radio-button>
          <div class="radio-sub-setting" *ngIf="ecommerceConnection.sendEmailMessage">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label i18n="@@Notification Email">Notification Email</mat-label>
              <input matInput [(ngModel)]="ecommerceConnection.notificationEmail" type="email"
                     i18n-placeholder="@@Notification Email Placeholder" placeholder="email@example.com">
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
          </div>
          <mat-radio-button [value]="false">
            <div class="radio-option">
              <strong i18n="@@SendEmailNotificationsDisabled">Do not send email notifications for this connection.</strong>
              <div class="radio-option-description" i18n="@@descriptionSendEmailNotificationsDisabled">No email notifications will be sent. Issues will still be visible in the account interface but will not trigger email alerts.</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-expansion-panel>

    <!-- Section: Shipment & Order Status Updating -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">sync</mat-icon>
          <span i18n="@@Shipment and Order Status Updating">Shipment & Order Status Updating</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="section-form">
        <!-- Synchronize Shipments -->
        <h4 class="settings-heading" i18n="@@Synchronize Shipments">Synchronize Shipments</h4>
        <div class="settings-description" i18n="@@descriptionShipmentOrderStatus">Configure how shipment tracking and order completion information is reported back to your ecommerce store.</div>
        <mat-radio-group class="radio-group-vertical" [value]="ecommerceConnection.synchronizeShipments" (change)="ecommerceConnection.synchronizeShipments = $event.value">
          <mat-radio-button [value]="true">
            <div class="radio-option">
              <strong i18n="@@SynchronizeShipmentsEnabled">Synchronize shipment tracking with the ecommerce store.</strong>
              <div class="radio-option-description" i18n="@@descriptionSynchronizeShipmentsEnabled">Shipment tracking information will be sent to your ecommerce store as packages are shipped, allowing your customers to track their deliveries.</div>
            </div>
          </mat-radio-button>
          <mat-radio-button [value]="false">
            <div class="radio-option">
              <strong i18n="@@SynchronizeShipmentsDisabled">Do not synchronize shipment tracking.</strong>
              <div class="radio-option-description" i18n="@@descriptionSynchronizeShipmentsDisabled">Shipment tracking information will not be sent to your ecommerce store. Customers will not receive tracking updates through the store.</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>

        <mat-divider></mat-divider>

        <!-- Remote Order State -->
        <h4 class="settings-heading" i18n="@@Remote Order State">Remote Order State</h4>
        <div class="settings-description" i18n="@@descriptionRemoteOrderState">When set, the order status in your ecommerce store will be updated to the selected value when all items in the order have been shipped.</div>
        <mat-form-field appearance="outline">
          <mat-label i18n="@@Remote Order State">Remote Order State</mat-label>
          <mat-select [(ngModel)]="ecommerceConnection.remoteOrderState">
            <mat-option value="" i18n="@@Do Not Update">Do Not Update</mat-option>
            <mat-option value="COMPLETED" i18n="@@Completed">Completed</mat-option>
            <mat-option value="FULFILLED" i18n="@@Fulfilled">Fulfilled</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- Section: Connection Details -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="section-icon">info</mat-icon>
          <span i18n="@@Connection Details">Connection Details</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="section-form">
        <div class="form-row">
          <div class="flex-field"><strong i18n="@@Id:">Id:</strong> {{ecommerceConnection.ID}}</div>
          <div class="flex-field"><strong i18n="@@State">State</strong>: {{ecommerceConnection.state}}</div>
        </div>
        <div class="form-row">
          <div class="flex-field"><strong i18n="@@URL:">URL:</strong> {{ecommerceConnection.remoteURL}}</div>
          <div class="flex-field"><strong i18n="@@User:">User:</strong> {{ecommerceConnection.remoteUser}}</div>
        </div>
        <div class="form-row">
          <div class="flex-field"><strong i18n="@@Default Shipping Service">Default Shipping Service</strong>: {{ecommerceConnection.defaultShippingService}}</div>
          <div class="flex-field"><strong i18n="@@Default Free Shipping Service">Default Free Shipping Service</strong>: {{ecommerceConnection.defaultFreeShippingService}}</div>
        </div>
        <div class="form-row">
          <div class="flex-field"><strong i18n="@@Carrier Service Map">Carrier Service Map</strong>: {{ecommerceConnection.carrierServiceMap_ID}}</div>
          <div class="flex-field"><strong i18n="@@Remote Order State">Remote Order State</strong>: {{ecommerceConnection.remoteOrderState}}</div>
        </div>
      </div>
    </mat-expansion-panel>

  </mat-accordion>
</div>
